import { Component, OnInit, Input } from '@angular/core';

import { InvestOutputDetail } from '@classes/invest/invest-sic/invest-output-detail';

@Component({
    selector: 'app-loaning',
    templateUrl: './loaning.component.html',
    styleUrls: ['./loaning.component.scss']
})
export class LoaningComponent implements OnInit {
    @Input() interests: InvestOutputDetail;
    @Input() depreciations: InvestOutputDetail;

    constructor() { }

    ngOnInit() {
    }

}
